"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.firstMapKey = void 0;
const first_map_entry_1 = require("./first-map-entry");
exports.firstMapKey = (map) => first_map_entry_1.firstMapEntry(map)[0];
//# sourceMappingURL=first-map-key.js.map